const env = {
  "bo-dev": "https://bo-dev.mapcard.pro",
  "bo-stage": "https://bo-stage.mapisacard.com",
  "bo-evo": "https://bo-evo.mapisacard.com"
};

const auth0 = {
  "bo-dev": "PzB95YCVstd8OHlhEkiR9t22IEnQriK5",
  "bo-stage": "MiEBa4Mx5TbAFCasxGsLjnm0AUFAbRvL",
  "bo-evo": "2jc4hH10i67vYiCWO9qn0Z4noWxLmcBA"
};

// const auth = {
//   'bo-dev': 'https://identity-stage.mapcard.pro',
//   'bo-stage': 'https://identity-stage.mapcard.pro',
//   'bo-evo': 'https://identity-evo.mapcard.pro'
// }

const auth = {
  'bo-stage.mapcard.pro': 'https://identity-stage.mapcard.pro',
  'bo-evo.mapcard.pro': 'https://identity-evo.mapcard.pro',
  'cabinet-stage.rocketpay.kz ': 'https://identity-stage.mapcard.pro',
  'cabinet.rocketpay.kz': 'https://identity-evo.mapcard.pro',
}
//
// const auth = {
//   'bo-dev': 'https://identity-stage.mapcard.pro',
//   'bo-stage': 'https://id-stage.mapcard.pro', // this is a new form url
//   'bo-evo': 'https://identity-evo.mapcard.pro'
// }

const origin = window.location.origin;
const hostname = window.location.hostname;
let pathname = window.location.pathname;

let apiUrl = "";
let baseUrl = "";
let clientId = "";
const loginUrl = auth[hostname] || 'https://identity-stage.mapcard.pro';

if (hostname && hostname == "localhost") {
  apiUrl = "http://localhost:3001/api/";
  pathname = "/";
  baseUrl = origin + pathname;
  clientId = auth0["bo-stage"];
} else {
  let level = origin.match(/bo-[a-z]{3,5}/);
  level = level !== null ? level[0] : ''
  if (level == "bo-dev") {
    //(.com)(\/.*\/)
    pathname = pathname.match(/(\/(feature-.*?|develop))\//)[0];
    console.log("TCL: pathname", pathname);
    apiUrl = "/api" + pathname;
    clientId = auth0["bo-dev"];
  } else {
    apiUrl = "/api/";
    pathname = "/";
    clientId = level == "bo-evo" ? auth0["bo-evo"] : auth0["bo-stage"];
  }

  baseUrl = origin + pathname;
}

export {
  apiUrl,
  baseUrl,
  pathname,
  clientId,
  loginUrl
};
